import attrAttr from "./attr-attr.svg";
import attrNum from "./attr-num.svg";
import geometry from "./geometry.svg";
import attr from "./attr.svg";

export const images = {
  attrAttr,
  attrNum,
  geometry,
  attr,
};
